import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { getApiErrorMessage } from "../getApiErrorMessage";

interface RequestReservationChangePayload {
  reservationId: number;
  newEventId: number;
}

const requestReservationChange = async ({
  reservationId,
  newEventId,
}: RequestReservationChangePayload): Promise<void> => {
  const response = await apiFetch(
    `api/admin/reservation-requests/${reservationId}/request-change`,
    {
      method: "POST",
      body: JSON.stringify({ newEventId }),
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error(await getApiErrorMessage(response));
  }
};

export const useRequestReservationChange = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestReservationChange,
    // Returning the promise keeps the mutation pending until the refetch finishes.
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: ["events", "admin"] }),
        queryClient.invalidateQueries({ queryKey: ["reservation-requests", "admin"] }),
      ]),
    onError: (error) => {
      console.error("Request reservation change failed:", error);
    },
  });
};
